window.addEventListener('DOMContentLoaded', function () {

  function headerPosition() {
    var header = document.getElementById('js-header');
    var areaSP = document.getElementById('areaSp');

    if (header != null && areaSP != null) {
      var style =
        areaSP.currentStyle ||
        document.defaultView.getComputedStyle(areaSP, '');
      if (style.display == 'block') {
        header.style.top = '120px';
      }
      window.addEventListener('scroll', function () {
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (style.display == 'block' && scrollTop == 0) {
          header.style.top = '120px';
        } else {
          header.style.removeProperty('top');
        }
      });
    }
  }



  function headerMIn() {
    var headerH = $("#header").outerHeight(true);//headerの高さを取得
  }
  function pageTopBtn() {
    var scrollToggleClass = function (scrollPos) {
      var targetTop = document.getElementById('js-targetBtn');
      var triggerMargin = 300;
      if (triggerMargin < scrollPos) {
        targetTop.classList.add('targetTop--show');
      } else {
        targetTop.classList.remove('targetTop--show');
      }
    };

    window.addEventListener('scroll', function () {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrollToggleClass(scrollTop);
    });


    var easeFunctions = {
      easeInQuad: function (t, b, c, d) {
        t /= d;
        return c * t * t + b;
      },
      easeOutQuad: function (t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
      },
    };
    var moveTo = new MoveTo(
      {
        duration: 800,
        ease: 'easeInQuad',
      },
      easeFunctions
    );
    var triggers = document.getElementsByClassName('js-pageTopTrigger');
    for (var i = 0; i < triggers.length; i++) {
      moveTo.registerTrigger(triggers[i]);
    }
  }

  function headerScrollFixed() {
    var fixHeader = function (position, lastPosition) {
      var header = document.getElementById('js-header');
      var headerNav = document.getElementsByClassName('headerNav__listItem');
      var headerOverlay = document.getElementById('js-headerOverlay');
      if (header != null) {
        var headerHeight = header.clientHeight;
        if (position > headerHeight && position > lastPosition) {
          header.classList.add('header--unpinned');
          Array.prototype.forEach.call(headerNav, function (element) {
            if (element.classList.contains('headerNav__listItem--isOpen')) {
              element.classList.remove('headerNav__listItem--isOpen');
              headerOverlay.classList.remove('headerOverlay--isHover');
            }
          });
        }
        if (position < headerHeight || position < lastPosition) {
          header.classList.remove('header--unpinned');
        }
      }
    };

    var lastPosition = 0;
    window.addEventListener('scroll', function () {
      var position = window.scrollY || window.pageYOffset;
      fixHeader(position, lastPosition);
      lastPosition = position;
    });
  }



  function hamburgerClickIcon() {
    var trigger = document.querySelector('.js-hamburgerOpen');
    var targetMenu = document.getElementById('js-openMenu');
    var body = document.querySelector('body');
    var overlay = document.getElementById('js-overlay');
    var scrollPos;

    if (trigger != null) {
      trigger.addEventListener('click', function () {
        var winWidth = window.innerWidth;
        if (targetMenu.classList.contains('hamburgerMenu--isActive')) {
          targetMenu.classList.remove('hamburgerMenu--isActive');
          body.classList.remove('isNavOpened');
          body.style.removeProperty('top');
          window.scrollTo(0, scrollPos);
        } else {
          scrollPos =
            document.documentElement.scrollTop || document.body.scrollTop;
          targetMenu.classList.add('hamburgerMenu--isActive');
          body.classList.add('isNavOpened');
          if (winWidth <= 767) {
            body.style.top = -scrollPos + 'px';
          }
        }
      });

      overlay.addEventListener('click', function () {
        body.classList.remove('isNavOpened');
        targetMenu.classList.remove('hamburgerMenu--isActive');
        body.style.removeProperty('padding-right');
        body.style.removeProperty('top');
        window.scrollTo(0, scrollPos);
      });

      targetMenu.addEventListener('scroll', function () {
        var scrollY = targetMenu.scrollTop;
        if (scrollY > 0) {
          trigger.style.display = 'none';
        } else {
          trigger.style.display = 'block';
        }
      });
    }
  }


  function hamburgerShowMenu() {
    var lists = [];
    var wrapperMenu = document.getElementById('js-hamburgerMenu');
    var clickMenu = document.querySelectorAll('.hamburgerMenu__listItem');
    var contentMenu = document.querySelectorAll('.hamburgerSubMenu__wrapper');

    for (var i = 0; i < contentMenu.length; i++) {
      lists.push(contentMenu[i]);
    }

    var resetClass = function () {
      Array.prototype.forEach.call(lists, function (element) {
        element.classList.remove('hamburgerSubMenu__wrapper--isOpen');
        element.removeAttribute('id');
      });
      Array.prototype.forEach.call(clickMenu, function (element) {
        element.classList.remove('hamburgerMenu__listItem--active');
      });
    };

    Array.prototype.forEach.call(clickMenu, function (elm, index) {
      elm.addEventListener('click', function () {
        if (this.classList.contains('hamburgerMenu__listItem--hasLink')) {
          return false;
        }
        resetClass();
        this.classList.add('hamburgerMenu__listItem--active');
        lists[index].setAttribute('id', 'hamburgerSubMenuOpen');
        lists[index].classList.add('hamburgerSubMenu__wrapper--isOpen');
        wrapperMenu.classList.add('hamburgerMenu__body--isOpen');
      });
    });
  }

  function dropdownShowMenu() {
    var headerOverlay = document.getElementById('js-headerOverlay');
    var dropdownItem = document.querySelectorAll('.headerNav__listItem');
    var lists = [];
    for (var i = 0; i < dropdownItem.length; i++) {
      lists.push(dropdownItem[i]);
    }
    for (var j = 0; j < lists.length; j++) {
      (function (i) {
        lists[i].addEventListener('mouseenter', function () {
          headerOverlay.classList.add('headerOverlay--isHover');
          lists[i].classList.add('headerNav__listItem--isOpen');
          if (lists[i].classList.contains('headerNav__listItem--hasLink')) {
            headerOverlay.classList.remove('headerOverlay--isHover');
          }
        });
        lists[i].addEventListener('mouseleave', function () {
          headerOverlay.classList.remove('headerOverlay--isHover');
          lists[i].classList.remove('headerNav__listItem--isOpen');
        });
      })(j);
    }
  }


  headerPosition();
  pageTopBtn();
  headerScrollFixed();
  hamburgerClickIcon();
  hamburgerShowMenu();
  dropdownShowMenu();
});
